import { Container, Text, TextStyle } from 'pixi.js';

const style = new TextStyle({
  fontFamily: 'monospace',
  fontSize: 11,
  fill: 0xffffff,
  stroke: { color: 0x000000, width: 3 },
  align: 'center',
});

export class NameLayer {
  readonly container: Container;
  private text: Text;
  private currentName: string = '';

  constructor() {
    this.container = new Container();
    this.text = new Text({ text: '', style });
    this.text.anchor.set(0.5, 1);
    this.container.addChild(this.text);
  }

  update(name: string, radius: number): void {
    if (name === this.currentName && this.text.position.y === -radius - 6) return;
    this.currentName = name;
    this.text.text = name;
    this.text.position.y = -radius - 6;
  }

  setVisible(visible: boolean): void {
    this.container.visible = visible;
  }

  destroy(): void {
    this.container.removeChildren();
    this.text.destroy();
  }
}
